import { render } from "./UserEdit.vue?vue&type=template&id=0b54ef93"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"
script.render = render

export default script